export default __webpack_public_path__ + "static/media/todo-screenshot-02.009b399e.png";